<div class="d-flex no-color justify-content-center" [style.height]="containerHeight+'px'">
<label *ngIf="label" class="vertical_label" [ngClass]="type === 0 ? 'used' : 'attachable'">{{ label }}</label>
<div *ngIf="containerHeight" class="imgbox" [style.height]="containerHeight + 'px'" [style.max-width]="src | imageAspectRatioPipe : containerHeight">
    <div class="delt_btn" *ngIf="isDeleteable">
        <!-- <i class="fa fa-trash" (click)="deleteImage.emit()"></i> -->
        <fap-round-button [action]="ButtonTypes.DELETE" [backgroundColor]="'tertiary'" (clicked)="deleteImage.emit()"></fap-round-button>
    </div>
    <img alt="" [src]="src">
</div>
</div>